import React, { useState } from "react";
import { Button, Image, Modal, Form } from "semantic-ui-react";
import { LEASE_MANAGER } from "../../utils/constants";
import { sendLoyaltyPointGql } from "../../store/person/loyalty";
import { AddConcessions } from "../../store/person/leases";
import { getClient } from "../../init-apollo-googleFn";
import mixpanel from "mixpanel-browser";
import { parseGraphQLErrors, toastFailMsg, toastSuccessMsg } from "../../utils/common";
import { getEmitter } from "../../utils";
import pointsIcon from "../../assets/images/points-icon.svg";
import giftIcon from "../../assets/images/gift-points-icon.svg";
import LeaLoader from '../PageLoader/LeaLoader';

const eventEmit = getEmitter();

const leaseClient = getClient(LEASE_MANAGER);

function ConcessionsModal(prop) {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [amount, setAmount] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const sendGift = () => {
    setIsSubmitting(true);
    mixpanel.track("Manager Loyalty Action", {
      sub: "Gift Points to User",
    });
    leaseClient
      .mutate({
        mutation: AddConcessions,
        variables: {
          package: {
            personId: prop.recipient,
            leaseId: prop.leaseID,
            concessionAmount: amount,
            description: message,
          },
        },
      })
      .then((res) => {
        toastSuccessMsg("Successfully gave Concessions to user");
        setIsSubmitting(false);
        onClose();
      })
      .catch((e) => {
        toastFailMsg("Trouble processing request, please refer to system admin");
        setIsSubmitting(false);
        onClose();
      });
  };

  const onClose = () => {
    setOpen(false);
    setAmount(false);
    setMessage("");
  }

  return (
    <Modal
      className="semanticModal loyalty-points-modal"
      closeIcon
      onClose={() => onClose()}
      onOpen={() => setOpen(true)}
      open={open}
      size="small"
      trigger={
        prop.from !== "ViewLead" ? (
          <Button className="btn-gradient">
            {" "}
            <Image src={pointsIcon} alt="points" /> Add Concessions
          </Button>
        ) : (
          <div>Add Concessions</div>
        )
      }
    >
      {/* <Modal.Header>Gift Loyalty Points</Modal.Header> */}
      <Modal.Content>
        <Modal.Description>
          <div className="points-icon">
            <Image src={giftIcon} alt="points" />
          </div>
          <div className="points-modal-title">Add Concessions</div>
          <div className="points-modal-description">
            Add concessions to this users lease.
          </div>
          <Form>
            <Form.Input
              label="Amount"
              placeholder="Amount"
              type="number"
              name="name"
              onChange={({ target: { value } }) => {
                setAmount(value);
              }}
            />
            {/* <div className='points-balance'>Points Balance: 500</div> */}
            <Form.TextArea
              label="Description"
              placeholder="Input Description Here"
              value={message}
              maxLength={155}
              onChange={({ target: { value } }) => {
                setMessage(value);
              }}
            />
            <p>{message.length}/155 characters</p>
            <Button
              fluid
              style={{backgroundColor: !amount && '#4c158a'}}
              className="btn-gradient"
              disabled={!amount || isSubmitting}
              onClick={() => sendGift()}
            >
              {isSubmitting ?
                <LeaLoader wrapperStyle={{position: 'static', height: '40px', width: '40px', margin: '16px auto 0 auto'}} logoStyle={{height: '60px'}}/>
              :
                "Add Concessions"
              }
            </Button>
          </Form>
        </Modal.Description>
      </Modal.Content>
    </Modal>
  );
}

export default ConcessionsModal;
